import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import imageBorder from "../../assets/images/bestsellerborder.webp";
import axios from "axios";
import { COMPANY_INFO_API } from "../../config/config";
import { useLocation } from "react-router-dom";

export const Companyinfo = () => {
  const [companyInfo, setCompanyInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const { pathname } = location;
  const pathSegments = pathname.split("/").filter(Boolean); // removes empty strings
  const dynamicCityFromURL = pathSegments.length >= 1 ? pathSegments[0] : "Surat";
  const selectedLocation = dynamicCityFromURL.toLowerCase();

  // Update storage data when location changes
  const [storageData, setStorageData] = useState({
    locationDynamic: "LOCATION_DY",
    locationReplace: selectedLocation,
  });

  useEffect(() => {
    setStorageData({
      locationDynamic: "LOCATION_DY",
      locationReplace: selectedLocation,
    });
  }, [selectedLocation]);

  const fetchCompanyInfoData = async () => {
    try {
      const response = await axios.get(`${COMPANY_INFO_API}`);

      if (response.data.aboutsection) {
        // Filter only the data with id: 1
        const filteredData = response.data.aboutsection.find(item => item.id === 1);

        if (filteredData) {
          setCompanyInfo(filteredData);
        } else {
          console.error("No data found for ID 1");
        }
      } else {
        console.error("Unexpected API response structure:", response.data);
      }
    } catch (error) {
      console.error("Error fetching company data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompanyInfoData();
  }, []);

  if (loading) {
    return <p>Loading...</p>;
  }

  return (
    <Container style={{ overflow: "hidden" }}>
      <Row className="pb-5 pt-3">
        <Col>
          <div className="text-center fs-1 saree-heading them-font">
            {companyInfo?.title}
          </div>
          <div className="d-flex justify-content-center">
            <img
              src={imageBorder}
              className="border-image py-2"
              alt="Kesaria Textile Company"
              loading="lazy"
            />
          </div>
          {companyInfo?.description && (
            <div
              className="them-font"
              style={{ wordBreak: "break-word" }}
            >
              <div
                className="text-sm xl:text-lg them-font"
                dangerouslySetInnerHTML={{
                  __html: companyInfo.description.replaceAll(
                    storageData?.locationDynamic,
                    storageData.locationReplace.charAt(0).toUpperCase() + storageData.locationReplace.slice(1)
                  ),
                }}
                style={{ textAlign: "justify", fontFamily: "jost", lineHeight: "1.5rem" }}
              />
            </div>
          )}
        </Col>
      </Row>
    </Container>
  );
};
